import { getZoomScale } from '~/client/src/shared/map/mapZoomRule'
import {
  MARKER_CLEARANCE_PX,
  PIN_SPEC,
} from '~/client/src/shared/map/markerGeometry'

// The Workflow pins a text markup's label keeps clear of, with the sizes their layer draws them at.
export interface IMarkupLabelPins {
  points: ReadonlyArray<{
    longitude: number
    latitude: number
    anchored?: boolean
  }>
  isZoomScalingEnabled: boolean
  iconScale?: number
  markerScale?: number
}

export interface IScreenBox {
  x: number
  y: number
  width: number
  height: number
}

export const screenBoxesMeet = (a: IScreenBox, b: IScreenBox): boolean =>
  a.x < b.x + b.width &&
  b.x < a.x + a.width &&
  a.y < b.y + b.height &&
  b.y < a.y + a.height

// Each pin's icon on screen at this zoom, standing on its tip and lifted clear of the Location
// marker it rides, as GLWorkflowPinLayer sizes it.
export function pinScreenBoxes(
  pins: IMarkupLabelPins,
  zoom: number,
  project: (lngLat: [number, number]) => { x: number; y: number },
): IScreenBox[] {
  const ramp = pins.isZoomScalingEnabled ? getZoomScale(zoom) : 1
  const iconScale = pins.iconScale ?? 1
  const height = PIN_SPEC.boxPx * iconScale * ramp
  const width = (height * PIN_SPEC.viewBoxWidth) / PIN_SPEC.viewBoxHeight
  const lift = MARKER_CLEARANCE_PX * (pins.markerScale ?? iconScale) * ramp
  return pins.points.map(pin => {
    const tip = project([pin.longitude, pin.latitude])
    return {
      x: tip.x - width / 2,
      y: tip.y - (pin.anchored ? lift : 0) - height,
      width,
      height,
    }
  })
}
